import * as reactIntl from 'react-intl';
import * as yup from 'yup';

export const filesAttachmentsValidation = (documents) => {
  const intl = reactIntl.useIntl();
  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  return yup.object().shape(
    documents.reduce((acc, doc) => {
      acc[doc.documentCode] = yup.object().shape({
        file:
          doc.mandatory === 'S'
            ? yup.mixed().required(requiredFieldMessage)
            : yup.mixed().nullable(),
        documentNumber:
          doc.mandatory === 'S' && doc.NumberMandatory === 'S'
            ? yup.string().required(requiredFieldMessage)
            : yup.string().nullable(),
        lifetime:
          doc.mandatory === 'S'
            ? yup.string().required(requiredFieldMessage)
            : yup.string().nullable(),
        expirationDate: yup.string().when('lifetime', {
          is: (val) => val === 'N',
          then: () => yup.date().required(requiredFieldMessage),
          otherwise: () => yup.string().nullable(),
        }),
      });
      return acc;
    }, {}),
  );
};
